import React, { Component } from 'react'
import { range, timer, easeCubic } from 'd3'

// get DPI
let dpi = window.devicePixelRatio

const data = {
  einkommensklasse: [50, 40, 9, 0.99, 0.01],
  anzahl: [2533932, 1266966, 760179, 253393, 202715, 25339, 20271, 4561, 507],
  color: ['#E23C4E', '#1D5F82', '#F8813D', '#54AF71', '#456558'],
  text: [
    "Max. Ein.: 52'000 Fr.",
    "Max. Ein.: 107'000 Fr.",
    "Max. Ein.: 322'000 Fr.",
    'Max. Einkommen: 4,3 Mio. Fr.',
    'Einkommen > 4,3 Mio. Fr.'
  ]
}

const height = 600 // window.innerHeight * 0.75;
const width = 250 // window.innerWidth * 0.7;
const numPoints = 900
const pointWidth = 3
const pointMargin = 3
const barMargin = 40
const graphBorder = 35
const barLength = 205
const font = ' TamediaChart,Helvetica,Arial,sans-serif'

// animation settings
const duration = 1000
const ease = easeCubic

// generate the array of points with a unique ID and color
let points = []
let levels = []

data['einkommensklasse'].forEach((klasse, i) => {
  let subpoints = range((numPoints / 100) * klasse).map(index => ({
    id: index,
    class: i,
    color: data['color'][i]
  }))
  points.push.apply(points, subpoints)
  let sublevels = {
    opacity: 0,
    barLength: 0,
    level: i
  }
  levels.push(sublevels)
})

function gridLayout(points, pointWidth, gridWidth, layoutLvl) {
  const pointHeight = pointWidth
  const pointsPerBar = Math.floor(
    (height -
      2 * graphBorder -
      (data['einkommensklasse'].length - 1) * barMargin) /
      data['einkommensklasse'].length /
      6
  )
  let group = 1
  let reset = 0
  points.forEach(point => {
    if (group !== point.class) {
      reset = 0
      group = point.class
    }
    if (layoutLvl !== '' && point.class >= layoutLvl) {
      point.x =
        width - 1 - pointHeight - pointWidth * Math.floor(reset / pointsPerBar)
      point.y =
        height -
        graphBorder -
        pointWidth * (reset % pointsPerBar) -
        point.class * (pointWidth * pointsPerBar + barMargin)
    } else {
      point.x = -10 * Math.random() * (width - 1 - pointWidth)
      point.y = Math.random() * (height - pointWidth)
    }
    reset += 1
  })
  return points
}

function randomLayout(points, pointWidth, width, height, layoutLvl) {
  points.forEach(point => {
    point.x = -20
    point.y = height * Math.random()
    if (point.class > layoutLvl) {
      point.x = -700 * (Math.random() * (width - 1 - pointWidth))
      point.y = Math.random() * (height - pointWidth)
    }
  })
  return points
}

const toGrid = (points, layoutLvl) =>
  gridLayout(points, pointWidth + pointMargin, width, layoutLvl)
const toRandom = (points, layoutLvl) =>
  randomLayout(points, pointWidth + pointMargin, width, width, layoutLvl)

class GraphLeft extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: width,
      height: height,
      layout: 'random'
    }
  }

  animate(layout, ctx) {
    // store the source position
    points.forEach(point => {
      point.sx = point.x
      point.sy = point.y
    })
    levels.forEach(level => {
      level.sBarLength = level.barLength
      level.sOpacity = level.opacity
    })

    // get destination x and y position on each point
    switch (layout) {
      case 'toGrid':
        layout = toGrid
        break
      case 'toRandom':
        layout = toRandom
        break
      default:
        layout = toRandom
        break
    }
    layout(points, this.props.layoutLvl)

    // store the destination position
    points.forEach(point => {
      point.tx = point.x
      point.ty = point.y
    })
    levels.forEach(level => {
      level.tBarLength = 0
      level.tOpacity = 0
      if (level.level >= this.props.layoutLvl) {
        level.tBarLength = barLength
        level.tOpacity = 0.8
      }
    })

    let time = timer(elapsed => {
      // compute how far through the animation we are (0 to 1)
      const t = Math.min(1, ease(elapsed / duration))
      // update bar length
      levels.forEach(level => {
        level.barLength = level.sBarLength * (1 - t) + level.tBarLength * t
        level.opacity = level.sOpacity * (1 - t) + level.tOpacity * t
      })
      // update point positions (interpolate between source and target)
      points.forEach(point => {
        point.x = point.sx * (1 - t) + point.tx * t
        point.y = point.sy * (1 - t) + point.ty * t
      })

      // update what is drawn on screen
      this.draw(ctx)

      if (t >= 1) {
        time.stop()
      }
    })
  }
  fixDpi(canvas, ctx) {
    // Give the canvas pixel dimensions of their CSS
    // size * the device pixel ratio.
    canvas.width = width * dpi
    canvas.height = height * dpi

    ctx.scale(dpi, dpi)
    return ctx
  }
  draw(ctx) {
    ctx.scale(this.props.scale, this.props.scale)
    ctx.clearRect(0, 0, width, height)
    ctx.lineWidth = 0.4
    ctx.beginPath()
    ctx.moveTo(this.state.width - 1, 0)
    ctx.lineTo(this.state.width - 1, this.state.height)
    ctx.stroke()

    ctx.font = '18px' + font
    ctx.fillStyle = 'rgba(0, 0, 0, 1)'
    ctx.fillText('Anteil Steuerpflichtige', 62, 20)

    levels.forEach((level, i) => {
      ctx.strokeStyle = data['color'][i]
      ctx.beginPath()
      ctx.moveTo(this.state.width - 5, 572 - 112 * i)
      ctx.lineTo(this.state.width - 5 - level.barLength, 572 - 112 * i)
      ctx.stroke()
      ctx.font = '15px' + font
      ctx.fillStyle = 'rgba(0, 0, 0, ' + level.opacity + ')'
      ctx.fillText(
        data['einkommensklasse'][i].toFixed(2).replace('.', ',') + '%',
        this.state.width - 55,
        587 - 112 * i
      )

      ctx.font = '12px' + font
      ctx.fillStyle = 'rgba(0, 0, 0, ' + level.opacity + ')'
      switch (i) {
        case 0:
          ctx.fillText(data['text'][i], this.state.width - 200, 585 - 112 * i)
          break

        case 1:
          ctx.fillText(data['text'][i], this.state.width - 200, 585 - 112 * i)
          break

        case 2:
          ctx.fillText(data['text'][i], this.state.width - 200, 567 - 112 * i)
          break
        case 3:
          ctx.fillText(data['text'][i], this.state.width - 200, 567 - 112 * i)
          break

        case 4:
          ctx.fillText(data['text'][i], this.state.width - 200, 567 - 112 * i)
          break
      }
    })

    for (let i = 0; i < points.length; ++i) {
      const point = points[i]
      ctx.fillStyle = point.color
      if (point.class === 4) {
        ctx.fillRect(point.x, point.y, 1, 1)
      } else {
        ctx.fillRect(point.x, point.y, pointWidth, pointWidth)
      }
    }
  }

  componentDidMount() {
    const canvas = this.refs.canvas

    let ctx = canvas.getContext('2d')
    ctx = this.fixDpi(canvas, ctx)
    // gridLayout(points, pointWidth + pointMargin, width)
    randomLayout(points, pointWidth + pointMargin, width, height)
    this.draw(ctx)
  }

  componentDidUpdate() {
    const canvas = this.refs.canvas
    const ctx = canvas.getContext('2d')
    this.animate(this.props.layout, ctx)
  }

  render() {
    return (
      <div>
        <canvas className='halfCanvas' ref='canvas' />
      </div>
    )
  }
}

export default GraphLeft
